import React from "react";

// Components
import { useQuery } from "react-query";
import { useHistory } from "react-router";

import { PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { isEmpty } from "lodash-es";

import * as S from "./styles";

import { fetchProductsIndex, ProductIndexQuery } from "../../../../../api/fulfillment/product";
// import { useFacilityIndex } from "../../../../../hooks/api/common/useFacilityIndex";
import Table from "../Table";
import { useFeatureFlagQuery } from "../../../../../hooks/useFeatureFlagQuery";
import { getColumns, useMergedProductInventories } from "../../../../fulfillment/FulfillmentProductIndexPage/helpers";
import { fetchInventories } from "../../../../../api/inventory";
interface ProductsTableProps {
  query: ProductIndexQuery;
}

const ProductsTable: React.FC<ProductsTableProps> = ({ query }) => {
  const history = useHistory();
  // const { data: facilities = [] } = useFacilityIndex();
  const organizationID = query.organization_id;

  const showStockDetails = useFeatureFlagQuery(
    "show-stock-details-on-products-api",
    { organization_id: organizationID },
    { enabled: !!organizationID }
  );

  const useNewWarehouseInventory = useFeatureFlagQuery(
    "use-new-warehouse-inventory-values",
    { organization_id: organizationID },
    { enabled: !!organizationID }
  );

  const productsQuery = useQuery(
    ["products", query, showStockDetails.data?.state],
    () => fetchProductsIndex({ ...query, with_stock_details: showStockDetails.data?.state }),
    { enabled: !isEmpty(query) }
  );
  const productIds = productsQuery.data?.data.map((p) => p.id) || [];

  const inventoriesQuery = useQuery(
    ["inventories", productIds],
    () =>
      fetchInventories({
        version: useNewWarehouseInventory.data?.state ? 2 : 1,
        organization_id: organizationID || "",
        ids: productIds,
        per_page: productIds.length,
      }),
    { enabled: !!organizationID && !!productIds.length }
  );

  const products = useMergedProductInventories(productsQuery, inventoriesQuery);

  const goToProductCreatePage = () => {
    history.push(`/organizations/${organizationID}/products/create`);
  };

  const tableProps = {
    columns: getColumns(organizationID || "", !!useNewWarehouseInventory.data?.state),
    dataSource: products || [],
    loading: productsQuery.isLoading,
  };

  const headerButtons = (
    <Button onClick={goToProductCreatePage} icon={<PlusOutlined />}>
      Add Product
    </Button>
  );

  return (
    <div className="fulfillment-table" id="products-table">
      <S.StyledProductsTable>
        <Table
          headerButtons={headerButtons}
          tableProps={tableProps}
          title="Products"
          fullListLink={organizationID ? `/organizations/${organizationID}/products` : null}
        />
      </S.StyledProductsTable>
    </div>
  );
};

export default ProductsTable;
